import React from "react";
import { AgentIcon, ChatAppIcon, LinkedInIcon, MailIcon, RcdIcon, VoiceIcon, WhatsappIcon } from "../../assets/icon";

// ─── Channel Icons (SVG) ───────────────────────────────────────────────────


const channels = [
    { icon: <WhatsappIcon />, label: "WhatsApp" },
    { icon: <ChatAppIcon />, label: "SMS" },
    { icon: <MailIcon />, label: "Email" },
    { icon: <RcdIcon />, label: "Chat" },
    { icon: <LinkedInIcon />, label: "LinkedIn" },
    { icon: <VoiceIcon />, label: "Push" },
    { icon: <AgentIcon />, label: "App" },
];

// ─── Side Panel ────────────────────────────────────────────────────────────
interface AuthSidePanelProps {
    imageSrc?: string;
}

export const AuthSidePanel: React.FC<AuthSidePanelProps> = ({ imageSrc }) => {
    return (
        <div className="hidden lg:flex flex-col my-6 xl:mr-10 rounded-xl min-h-screen relative overflow-hidden flex-shrink-0">

            {/* Background image */}
            {imageSrc ? (
                <img
                    src={imageSrc}
                    alt="ConvoHub background"
                    className="relative inset-0 w-full h-full object-cover"
                />
            ) : (
                <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-950" />
            )}

            {/* Overlay text */}
            <div className="absolute top-10 left-10 z-10 ">
                <h2 className="text-[48px] font-extrabold leading-tight bg-gradient-to-r from-[#FFFFFF] via-[#54EA32] to-[#FFDD55] bg-clip-text text-transparent">
                    <span className="">Reach customers,</span>
                    <br />
                    <span>not just inboxes.</span>
                </h2>
            </div>

        </div>
    );
};


// ─── Auth Footer ───────────────────────────────────────────────────────────
export const AuthFooter: React.FC = () => (
    <footer className="w-full text-center py-4 text-xs text-gray-400">
        © {new Date().getFullYear()} ConvoHub ·{" "}
        <a href="#" className="hover:text-gray-600 transition-colors">Privacy Policy</a>{" "}
        ·{" "}
        <a href="#" className="hover:text-gray-600 transition-colors">Terms of Service</a>
    </footer>
);

// ─── Auth Page Wrapper ─────────────────────────────────────────────────────
interface AuthLayoutProps {
    children: React.ReactNode;
    sideImageSrc?: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, sideImageSrc }) => {
    return (
        <div className="flex justify-center min-h-screen">
            {/* Left: form area */}
            <div className="flex flex-col lg:mx-4 2xl:mx-36 xl:mx-10 w-[657px]  min-h-screen">
                <div className="flex flex-1  px-6 py-12">
                    <div className=" w-full">
                        {children}
                    </div>
                </div>

                <div className="relative z-10   bg-[#FBF9F2] backdrop-blur-md rounded-2xl my-6 p-6 border border-white/20">
                    <p className="text-[#434343] font-medium text-center text-[20px] leading-snug mb-1">
                        Smarter targeting. Omnichannel engagements. Unified insights.
                    </p>
                    <p className="text-[#434343] text-[14px] text-center mb-5">
                        Bring WhatsApp, SMS, email, and more together to engage customers from a single inbox.
                    </p>

                    {/* Channel icons */}
                    <div className="flex justify-center gap-3 flex-wrap">
                        {channels.map((ch) => (
                            <div
                                key={ch.label}
                                title={ch.label}
                                className={` rounded-full  flex  shadow-lg`}
                            >
                                {ch.icon}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Right: side panel */}
            <AuthSidePanel imageSrc={sideImageSrc} />
        </div>
    );
};

export default AuthLayout;